import * as React from 'react';
import PropTypes from "prop-types";
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import Button from "../../components/Button";
import useDidMountEffect from "../../utils/useDidMountEffect";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import qs from "query-string";
import URL_SEARCH_PARAMETER_NAME from "../../utils/urlSearchParameterName";
import CodeCameraScannerModal from "../../components/CodeCameraScanner/CodeCameraScannerModal";
import {isDesktop} from "react-device-detect";
import {useTranslation} from "react-i18next";

function SearchInput(props) {
  const { t } = useTranslation('app_table')
  const [inputVisibleDelayFn, setInputVisibleDelayFn] = React.useState()
  const [valueDebounce$, setValueDebounce] = React.useState(new Subject());
  const inputRef = React.createRef();
  const [value, setValue] = React.useState('');
  const [inputVisible, setInputVisible] = React.useState(props.inputVisible);
  const [tooltipKey, setTooltipKey] = React.useState('');

  React.useEffect(() => {
    setTooltipKey(btoa(Math.random()).substr(5, 10));
  }, []);

  useDidMountEffect(() => {
    valueDebounce$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe(data => {
      props.onInputChanged(data)
    })

    const params = qs.parse(window.location.search);

    if(URL_SEARCH_PARAMETER_NAME in params && params[URL_SEARCH_PARAMETER_NAME]){
      setValue(params[URL_SEARCH_PARAMETER_NAME])
      setInputVisible(true)
      props.onInputChanged(params[URL_SEARCH_PARAMETER_NAME])
    }
  })

  useAfterUpdateEffect(() => {
    valueDebounce$.next(value)
  }, [value])

  React.useEffect(() => {
    if(props.inputVisible && inputRef?.current){
      setInputVisibleDelay(props.inputVisible);
      inputRef.current.focus();
    }
  }, [props.inputVisible]);

  const handleOnKeyUp = (e) => {
    switch (e.key) {
      case 'Enter': {
        props.onInputChanged(value)
        return;
      }
      case 'Escape': {
        setInputVisible(false);
        setValue('');
        props.onInputChanged('')
        return;
      }
      default: {

      }
    }

    setValue(e.target.value);
  };

  const setInputVisibleDelay = (inputVisible) => {
    clearTimeout(inputVisibleDelayFn)

    setInputVisibleDelayFn(setTimeout(() => {
      setInputVisible(inputVisible)
    }, 180))
  }

  if(!inputVisible && !props.forceOpen){
    return <React.Fragment>
      <Button tooltip={t('filters.filter_by_text')} onClick={() => setInputVisible(true)} color="light"><i className="fa fa-search" /></Button>
    </React.Fragment>
  }

  return (
    <InputGroup className={`d-flex flex-nowrap ${props.className}`}>
      <Input
        autoFocus={!props.forceOpen}
        innerRef={inputRef}
        role="table-input-search"
        placeholder={t('filters.filter_by_text_input_text')}
        style={{width: '120px'}}
        onKeyUp={handleOnKeyUp}
        onChange={e => setValue(e.target.value)}
        onBlur={() => {
          if(value === ''){
            setInputVisibleDelay(false)
          }
        }}
        value={value}
      />
      <InputGroupAddon addonType="append" onClick={() => props.onInputChanged(value)}>
        {(!isDesktop && props.codeCameraScanner) && <CodeCameraScannerModal
          onModalOpen={modalOpen => {
            if (modalOpen) {
              setInputVisibleDelay(true)
            } else {
              if (value === '') {
                setInputVisibleDelay(false)
              }
            }
          }}
          onScan={setValue}
        />}
        <Button color="primary" className="m-0"><i className="fa fa-search" /></Button>
      </InputGroupAddon>
    </InputGroup>
  );
}

SearchInput.defaultProps = {
  forceOpen: false,
  inputVisible: false,
  codeCameraScanner: false,
};

SearchInput.propTypes = {
  codeCameraScanner: PropTypes.bool,
  onInputChanged: PropTypes.func.isRequired,
  inputVisible: PropTypes.bool,
  forceOpen: PropTypes.bool,
};

export default SearchInput;
